import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  FormattedMessageDiv,
  FormattedMessageWithClass,
  FormattedHTMLMessageDiv,
} from '../../commonComponents';
import Modal from '../baseModal';
import Proptypes from 'prop-types';
const lang = process.env.REACT_APP_LOCALE;

const ConfirmationModal = ({
  allow,
  notAllow,
  history,
  location,
  notAllowId,
  allowId,
  modalType,
  actionWillRemove,
}) => {
  const redirectTo = () => {
    const CUSTOM_QUIZ = process.env.REACT_APP_CUSTOM_QUIZ || 'no';

    if (CUSTOM_QUIZ === 'yes' && location.pathname === '/vm/result') {
      context.updateRecommendation(-1, -1);
    }
    history.push('/vm');
    document.body.classList.remove('open');
    notAllow();
  };

  return (
    <Modal
      onClose={notAllow}
      notAllow={notAllow}
      allow={modalType === 'camera' ? redirectTo : allow}
      footer={true}
      notAllowId={notAllowId}
      allowId={allowId}
    >
      <article className="modal--article">
        {modalType === 'camera' && (
          <React.Fragment>
            {lang == 'ja' ? (
              <React.Fragment>
                <FormattedMessageDiv
                  id="without_quiz.access_cam1"
                  defaultMessage="Define Would Like to"
                  className="modal--article__header"
                />
                <FormattedMessageDiv
                  id="without_quiz.access_cam2"
                  defaultMessage="Access the Camera"
                  className="modal--article__header"
                />
              </React.Fragment>
            ) : (
              <FormattedHTMLMessageDiv
                id="without_quiz.access_cam"
                defaultMessage="Define Would Like to Access the Camera"
                className="modal--article__header"
              />
            )}

            <FormattedMessageDiv
              id="without_quiz.access_cam_sub_text"
              defaultMessage="Used for Live Try on"
              className="modal--article__footer"
            />
          </React.Fragment>
        )}

        {modalType === 'removal' && (
          <React.Fragment>
            {actionWillRemove === 'looks' ? (
              <FormattedMessageWithClass
                id="permissions.allow_look_removal"
                defaultMessage="This action would remove applied look"
                className="text-large text-camera-pop-up"
              />
            ) : (
              <FormattedMessageWithClass
                id="permissions.allow_makeup_removal"
                defaultMessage="This action would remove applied makeup"
                className="text-large text-camera-pop-up"
              />
            )}
            <FormattedMessageWithClass
              id="permissions.allow_look_removal_sub_text"
              defaultMessage="Do you want to proceed?"
              className="text-small text-camera-pop-up-subtext"
            />
          </React.Fragment>
        )}
      </article>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  allow: Proptypes.func,
  notAllow: Proptypes.func,
  location: Proptypes.object,
  notAllowId: Proptypes.string,
  allowId: Proptypes.string,
  modalType: Proptypes.string,
  actionWillRemove: Proptypes.string,
};

export default withRouter(ConfirmationModal);
